import React from 'react'
import { useSession } from '../../../hooks/auth/useSession.hook'

export function TeamMemberProjectRoleContainer (props) {
  const auth = useSession()
  return props.roles.includes(auth.user?.projectRole ?? null) ? <>{props.children}</> : null
}
